/* eslint-disable import/prefer-default-export */
export const shortenProductNameMixin = {
  methods: {
    shortenProductName(productName) {
      if (!productName) return productName;
      if (productName.includes('Kymeta Broadband')) {
        return `KB ${productName.split(' ').slice(2).join(' ')}`;
      }
      if (productName.includes('Intelsat')) {
        return 'Intelsat FlexMove';
      }
      return productName;
    }
  }
}
